import React from 'react';
import PropTypes from 'prop-types';

export default function Loading({ zIndex = 9999, message = "Loading, please wait..." }) {
    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                width: '100vw',
                height: '100vh',
                background: 'linear-gradient(135deg, rgba(0, 0, 0, 0.92), rgba(0, 0, 0, 0.95))',
                backdropFilter: 'blur(8px)',
                WebkitBackdropFilter: 'blur(8px)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: zIndex,
                animation: 'fadeIn 0.3s ease-in-out'
            }}
        >
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '1.5rem',
                    padding: '2.5rem',
                    background: 'rgba(255, 255, 255, 0.05)',
                    borderRadius: '20px',
                    border: '1px solid rgba(255, 255, 255, 0.1)',
                    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(255, 255, 255, 0.05)',
                    animation: 'scaleIn 0.4s ease-out 0.1s both'
                }}
            >
                <div
                    style={{
                        width: '70px',
                        height: '70px',
                        borderRadius: '50%',
                        border: '4px solid rgba(255, 255, 255, 0.1)',
                        borderTopColor: '#4ade80',
                        borderRightColor: '#22c55e',
                        borderBottomColor: '#16a34a',
                        animation: 'spin 1s linear infinite',
                        boxShadow: '0 0 20px rgba(74, 222, 128, 0.3)'
                    }}
                />
                <p
                    style={{
                        color: 'rgba(255, 255, 255, 0.95)',
                        fontSize: '1rem',
                        fontWeight: 500,
                        textAlign: 'center',
                        margin: 0,
                        letterSpacing: '0.5px',
                        textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)',
                        animation: 'pulse 2s ease-in-out infinite'
                    }}
                >
                    {message}
                </p>
            </div>
            
            <style dangerouslySetInnerHTML={{
                __html: `
                    @keyframes fadeIn {
                        from { opacity: 0; }
                        to { opacity: 1; }
                    }
                    
                    @keyframes scaleIn {
                        from { opacity: 0; transform: scale(0.9); }
                        to { opacity: 1; transform: scale(1); }
                    }
                    
                    @keyframes spin {
                        from { transform: rotate(0deg); }
                        to { transform: rotate(360deg); }
                    }
                    
                    @keyframes pulse {
                        0%, 100% { opacity: 0.9; }
                        50% { opacity: 1; }
                    }
                `
            }} />
        </div>
    );
}

Loading.propTypes = {
    zIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    message: PropTypes.string
};

